import $ from 'jquery';
import { TestimonialStories } from './TestimonialStories';
import { TestimonialWidget } from './TestimonialWidget';
import { TestimonialFilters } from './TestimonialFilters';

export const allTestimonials = () => {
    if ($('#testimonials-page').exists()) {

        new TestimonialStories({
            previousArrow: $('.arrow-backdrop.left'),
            nextArrow: $('.arrow-backdrop.right'),
            userStoriesSelector: '.user-story-container',
            numberOfSlides: 14
        });

        new TestimonialFilters({filtersContainer: $('.filters-container'), testimonialsContainer: $('.filtered-testimonials')});

        if ($('.fixed-testimonials').exists()) {
            new TestimonialWidget({
                testimonialsContainerSelector: '.fixed-testimonials',
                testimonialSelector: '.single-testimonial:not(.dummy-2):not(.dummy-3)',
                minimizeButtonSelector: '.minimize-testimonial',
                rightArrowSelector: '.right-arrow',
                leftArrowSelector: '.left-arrow',
                playButtonSelector: '.play-button',
                videoSelector: '.testimonial-media',
                numberOfTestimonials: $('.single-testimonial:not(.dummy-2):not(.dummy-3)').length,
                delay: 5000
            });
        }
        
    }
};